<template>
  <div class="ultra_goods">
    <van-nav-bar
      title="选择商品支付"
      left-arrow
      @click-left="goBack"
      :class="{'isiOSX':isiOSX}"
    />
    <div class="box">
      <div class="empty"></div>
      <div class="content">
        <van-row class="ultraInfo" v-if="!showTip">
          <van-col span="24">
            <img class="avatar" :src="avatar" @error="defaultAvatar()">
            <p class="name">{{name}}<img src="../../assets/member/micro_ultra@2x.png"></p>
          </van-col>
        </van-row>
        <van-row class="list">
          <van-col span="24" class="item" v-for="(item,index) in list" :key='index'>
            <img :src="item.goods_pic" @error="defaultPro()">
            <p class="name">{{item.goods_name}}</p>
            <span class="price">￥<span>{{item.price[0]}}.</span>{{item.price[1]}}</span>
            <span class="purcharse" v-if="!showTip" @click="purcharse(item)">购买</span>
          </van-col>
        </van-row>
      </div>
    </div>
    <van-popup class="tipMSG" v-model="showTip">
      <div class="box1">
        <img src="../../assets/common/BG@2x.png">
        <p class="title">温馨提示</p>
        <p class="tips">{{TipMsg}}</p>
        <span class="right right_big" v-if="showBtn" @click="confirm()">确定</span>
      </div>
    </van-popup>
  </div>
</template>
<script>
import avatarDefault from '@/assets/common/avatar.png';
import productDefault from '@/assets/common/preload.png';
export default {
  data() {
    return {
      name: '',
      avatar: '',
      list: [],
      showTip: false,
      TipMsg: '',
      payParam: {
        // goods_id: 0,  //商品id
        // isScan: 1    //证明是扫码购买的商品
      },
      isiOSX: false,
      showBtn: true,

    };
  },
  created (){
    this.isiOSX = this.isIphoneX();//encodeURI(this.memberInfo.nickname)
    this.$api.setToken(this.$route.query.token);
    if(!this.$route.query.token) {
      this.showBtn = false;
      this.showPopup('请打开销巴生活app扫一扫');
    }else {
      this.getList();
    }
    
  },
  methods: {
    getList() {
        this.$api.get("/member/member/manager/goods/list", {manager_member_id: this.$route.query.manager_member_id}).then(res => {
          for(let i in res.goods) {
            res.goods[i].price = res.goods[i].goods_price.split('.')
          }
          this.list = res.goods;
          this.name = res.member.nickname;
          this.avatar = res.info.head_pic || avatarDefault;
    	}).catch(err => {
	        let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0]
	  		if(message.slice(0, 10) == 'timeout of') {
	  			this.$toast('网络不给力，请稍候重试');
	  		}else if(err.code == 200415 || err.code == 200416) {
          this.showPopup(message)
        }else {
	  			this.$toast(message);
	  		}
      });  
    },
    purcharse(item) {
      item.isScan = 1;
      item.manager_member_id = this.$route.query.manager_member_id;
      this.payParam = item;
      this.ultraPay();
    },
    ultraPay() {
      this.params(JSON.stringify(this.payParam), JSON.stringify(this.payParam), 'ultraPay');
    },
    showPopup(msg) {
	      this.showTip = true;
	      this.TipMsg = msg;
    },
    confirm() {
    	this.goBack()
    },
    goBack() {
    	this.params('', '', 'goBack');
    },
    defaultAvatar() {
      var img = event.srcElement;
		  img.src = avatarDefault;
		  img.onerror = null; //防止闪图
    },
    defaultPro() {
	  	var img = event.srcElement;
		  img.src = productDefault;
		  img.onerror = null; //防止闪图
	  }
  },
//mounted() {
//}
  
};
</script>
<style lang="less" scoped>
.ultra_goods {
  min-height: 100%;
  box-sizing: border-box;
  background: #3D7EFF;
  .van-nav-bar {
    height: 44px;
    line-height: 44px;
    padding-top: 24px;
    border: none;
    box-shadow: none;
    background: #3D7EFF;
    .van-nav-bar__title {
      color: #ffffff;
      font-size: 18px;
      font-weight: 400;
		}
		.van-nav-bar__text {
      color: #ffffff;
      font-size: 18px;
      font-weight: 400;
    }
    .van-icon {
      color: #ffffff;
    }
  }
  .van-hairline--bottom:after{
    border-bottom-width: 0px !important;
  }
  .isiOSX{
    padding-top: 44px;
  }
  .box {
    .empty {
      width: 100%;
      height: 46px;
      background: #3D7EFF;
    }
    .content {
      padding: 0 12px 12px;
      margin-top: -40px;
      .ultraInfo {
        height: 79px;
        background: #ffffff;
        border-radius: 8px;
        padding: 21px 18px;
        box-sizing: border-box;
        .avatar {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          float: left;
        }
        .name {
          color: #333;
          font-size: 18px;
          font-weight: bold;
          height: 36px;
          line-height: 36px;
          padding-left: 51px;
          img {
            width: 68px;
            margin-left: 6px;
            margin-top: -2px;
            display: inline-block;
            vertical-align: middle;
          }
        }
      }
      .list {
        background: #fff;
        border-radius: 8px;
        padding: 9px 18px;
        margin-top: 12px;
        .item {
          padding: 9px 0;
          height: 110px;
          box-sizing: border-box;
          position: relative;
          img {
            width: 92px;
            height: 92px;
            float: left;
            background: #D8D8D8;
          }
          .name {
            color: #333;
            font-size: 15px;
            line-height: 24px;
            height: 48px;
            padding-left: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            white-space: normal;
          }
          .price {
            color: #3D7EFF;
            font-size: 13px;
            height: 29px;
            line-height: 29px;
            padding-left: 12px;
            margin-top: 15px;
            display: inline-block;
            span {
              font-size: 18px;
            }
          }
          .purcharse {
            width: 58px;
            height: 28px;
            border: solid 1px #3D7EFF;
            border-radius: 15px;
            color: #3D7EFF;
            font-size: 15px;
            font-weight: 700;
            line-height: 28px;
            text-align: center;
            display: inline-block;
            position: absolute;
            bottom: 9px;
            right: 18px;
          }
        }
      }
    }
  }
  .tipMSG {
    width: 70%;
    border-radius: 10px;
    .box1 {
      img {
        display: block;
        width: 100%;
      }
      .title {
        color: #333;
        font-size: 15px;
        font-weight: 600;
        line-height: 47px;
        margin-top: 8px;
        text-align: center;
      }
      .tips {
        color: #333;
        font-size: 13px;
        line-height: 18px;
        text-align: center;
        margin-bottom: 30px;
        padding: 0 10px;
      }
      span {
        width: 50%;
        border-top: solid 1px #f2f2f2;
        line-height: 43px;
        color: #999;
        font-size: 14px;
        text-align: center;
        display: inline-block;
      }
      .right {
        color: #e6212f;
        width: calc(50% - 1px);
        border-left: solid 1px #f2f2f2;
      }
      .right_big {
        width: 100%;
        border-left: none;
      }
    }
  }
}

</style>


